import {
  ALLOWED_PROP_PREFIX,
  ALLOWED_PROPS,
  FA_BRANDS,
  FA_LIGHT,
  FA_STYLE_TOKEN,
  FA_TOKEN,
} from './constants';

/**
 * Keep only valid FA tokens, dropping any layout or utility class an untrusted
 * icon string might smuggle through.
 */
export const sanitizeFaClasses = (name: string): string => {
  const tokens = name
    .split(/\s+/)
    .filter((token) => FA_TOKEN.test(token) && !FA_STYLE_TOKEN.test(token));

  return [tokens.includes(FA_BRANDS) ? null : FA_LIGHT, ...tokens]
    .filter(Boolean)
    .join(' ');
};

/**
 * Keep only the presentational surface. The icon name is not the only thing
 * that arrives from an untrusted payload — the props beside it do too, and an
 * `onClick` or a `dangerouslySetInnerHTML` spread onto the glyph is the same
 * hole as a layout class in the name.
 */
export const allowedIconProps = (
  props: Record<string, unknown>,
): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(props).filter(
      ([key]) => ALLOWED_PROP_PREFIX.test(key) || ALLOWED_PROPS.has(key),
    ),
  );
